import { createContext } from "react";

export const AccordionListContext = createContext<Value>({ size: "large" });

interface Value {
  size: "medium" | "large";
}
